(ns ductile.workflow.equipment-utils)

(def equipment-re #"^(\d+)?\s?(.*)$")

(defn parse-count+option-str [count+option]
  (let [[n option] (drop 1 (re-find equipment-re count+option))
        n (if n (parse-long n) true)]
    [option n]))

(defn- equipment-spec->default [strs]
  (->> strs
       (map parse-count+option-str)
       (into {})))

(defn equipment-set->map [strs-set]
  (->> strs-set
       equipment-spec->default))

(defn equipment-spec->options
  ([enum-strs] (equipment-spec->options enum-strs nil))
  ([enum-strs defaults-strs]
   (let [defaults (equipment-spec->default defaults-strs)]
     (->> enum-strs
          (reduce (fn [acc count+option-str]
                    (let [[option n] (parse-count+option-str count+option-str)]
                      (if (and (number? n)
                               (= option (:option (first acc))))
                        (conj (drop 1 acc) (update (first acc) :max (comp inc #(or % 1))))
                        (conj acc (cond-> {:option option}
                                    defaults-strs (assoc :default (defaults option)))))))
                  '())
          reverse))))

(defn equipment-map->set [map-count]
  (->> map-count
       (map (fn [[option n]]
              (cond
                (and (integer? n) (pos? n))
                (str n " " option)

                (true? n)
                option)))
       (filter identity)
       set))


(comment
  (equipment-spec->default ["Fgzschein"])
  (equipment-spec->options ["Fahrzeugschein"
                            "0 Schlüssel"
                            "1 Schlüssel"
                            "2 Schlüssel"
                            "3 Schlüssel"
                            "Navigations-DVD/CD/SD"
                            "Displaykey"
                            "0 Keycard"
                            "1 Keycard"
                            "2 Keycard"
                            "3 Keycard"
                            "Anhängerkupplung inkl. Kopf"]
                           ["2 Schlüssel"
                            "Fahrzeugschein"
                            "2 Kennzeichen"])
  (equipment-spec->options ["Fahrzeugschein"
                            "0 Schlüssel"
                            "1 Schlüssel"
                            "2 Schlüssel"
                            "3 Schlüssel"
                            "Navigations-DVD/CD/SD"
                            "Displaykey"
                            "0 Keycard"
                            "1 Keycard"
                            "2 Keycard"
                            "3 Keycard"
                            "Anhängerkupplung inkl. Kopf"])

  (->> {"Keycard" 3
        "Schlüssel" 1
        "Fahrzeugschein" true}
       equipment-map->set)

  (-> #{"2 Schlüssel" "Keycard"}
      equipment-set->map)

  (equipment-set->map #{})

  {"Schlüssel" 2
   "Keycard" true}



  [{:option "Schlüssel"
    :max 3}
   {:option "Keycard"
    :max 3}
   {:option "Navigations-DVD/CD/SD"}
   {:option "Anhängerkupplung inkl. Kopf"}]

  :rcf)
